module.exports = __webpack_public_path__ + "static/img/aepic-6.028ae42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-6.jpg
// module id = olLq
// module chunks = 52